<div class="popover bs-popover-right">
    <div class="arrow" style="top:calc(50% - 13px);"></div>
    <div class="popover-body">
        {{text}}
    </div>
</div>